import { ID } from "@closerplatform/closer-sdk/dist/protocol/protocol";
import { UserGetter } from "@fidget/common/closer";
import { MessageTag } from "@fidget/common/models/messageTag";
import { ForeContext } from "../context";

export const MESSAGE_FILTERS: Array<MessageTag> = [
  MessageTag.CALL_ANSWERED,
  MessageTag.CALL_ENDED,
  MessageTag.CONTACT_ENQUIRY,
  MessageTag.CONTACT_ENQUIRY_WITHOUT_GDPR,
  MessageTag.MESSAGE_WITH_ATTACHMENTS,
  MessageTag.MEETING,
  MessageTag.MEETING_SCHEDULED,
  MessageTag.MEETING_RESCHEDULED,
  MessageTag.MEETING_CANCELLED,
  MessageTag.LEKTA_MESSAGE,
  MessageTag.CALL_UNSUCCESSFUL,
  MessageTag.CALL_PROPOSAL,
  MessageTag.COBROWSING_PROPOSAL,
  MessageTag.COBROWSING_ACCEPTATION,
  MessageTag.COBROWSING_SESSION_ENDED,
  MessageTag.COBROWSING_SESSION_STARTED,
  MessageTag.MESSAGE_WITH_FORM
];

export function userGetter(context: ForeContext): UserGetter {
  return (id: ID) => context.state.shared.agents.get(id) || context.state.profile;
}
